
const LOCAL_STORAGE_KEY = {
  SDK_ACCESS_TOKEN: 'affinidi:accessToken'
}

export default LOCAL_STORAGE_KEY
